import '@babel/polyfill'
import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'swiper/css/swiper.min.css'
import 'element-plus/dist/index.css'
// import '@/common/js/jquery-3.6.0.min.js'

createApp(App).use(store).use(router).mount('#app')
